import React,{Fragment} from 'react';
import LoadingSpinner from '../../../../../utils/LoadingSpinner';
import LoadMoreNewTabletOrdersNotificationModalItems from './LoadMoreNewTabletOrdersNotificationModalItems';
const TabletNewOrdersNotificationModalBody = (props)  => {
    const order = props.order;
    /* console.log('order.total_existing_orders')
    console.log('order.total_existing_orders')
    console.log('order.total_existing_orders')
    console.log(order.total_existing_orders) */
    if (Object.keys(order).length === 0 || order.newTabletNotificationOrders === undefined) {
        return (
            <LoadingSpinner subClass={'mt10 mb10 text-center'} />
        )
    }else{

    }
    return (
        <Fragment>
            <div className="row">
                <div className="table-responsive">   
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Order Type</th>
                                <th>Name</th>
                                <th>Time</th>
                                <th>Total Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                order.newTabletNotificationOrders !== 'undefined' && order.newTabletNotificationOrders !== undefined ?
                                    <LoadMoreNewTabletOrdersNotificationModalItems
                                        limit={props.limitExstingOrders}
                                        total_new_tablet_notification_orders={order.total_new_tablet_notification_orders}
                                        Orders={order.newTabletNotificationOrders}
                                        onClickHandleLoadMoreNewTabletNotificationOrderItems={props.onClickHandleLoadMoreNewTabletNotificationOrderItems}
                                        handelOnClickTabletNewOrder={props.handelOnClickTabletNewOrder}
                                    />
                                :null
                            }
                        </tbody>
                    </table>

                    {
                        props.isloadingExistingOrders ? <LoadingSpinner subClass={'mt10 mb10 text-center'} /> :null
                    }
                </div>
            </div>
        </Fragment>
    );
}

export default TabletNewOrdersNotificationModalBody;